import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactTable from "react-table";
import { Button, Input, Icon, Flag, Popup, Dropdown } from 'semantic-ui-react';
import { NewRefundRequestModal, EditReturnedRefundModal, ReviewRefundRequestModal } from '../../components';
import moment from 'moment';
import { sortPriorities, defaultSort } from '../../helpers';
import copy from 'copy-to-clipboard';
import qs from 'qs';

import "semantic-ui-css/components/button.min.css";
import "semantic-ui-css/components/label.min.css";
import "semantic-ui-css/components/input.min.css";
import "semantic-ui-css/components/icon.min.css";
import "semantic-ui-css/components/flag.min.css";
import "semantic-ui-css/components/popup.min.css";

import "../../react-table.css";
import './RefundRequestor.css';

export default class RefundRequestor extends Component {
  static propTypes = {
    fetchRefundData: PropTypes.func,
    getZendeskData: PropTypes.func,
    zendeskData: PropTypes.obj,
    getOperatorData: PropTypes.func,
    notifyUser: PropTypes.func,
    operators: PropTypes.arr,
    refunds: PropTypes.array,
    resetZendeskFields: PropTypes.func,
    getTransactions: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      returned: true,
      msisdn: null,
      modalOpen: false,
      editModalOpen: false,
      showReviewModal: false
    }
  }

  componentDidMount() {
    const { returned, msisdn } = this.state;
    const { zendeskTicket } = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
    if(zendeskTicket) {
      this.setState({ initialZendeskTicket: zendeskTicket, modalOpen: true });
    }
    this.props.getRefundData({
      returned,
      msisdn
    });
    this.props.getOperatorData();
  }

  toggleReturned = () => {
    if(this.state.msisdn) {
      this.props.getRefundData({
        returned: !this.state.returned
      })
      this.setState({returned: !this.state.returned, msisdn: ''})
    }
  }

  onMsisdnChange = (e, {value}) => {
    this.setState({msisdn: value})
    if(value){
      this.props.getRefundData({
        msisdn: value
      })
    } else {
      this.props.getRefundData({
        returned: true
      })
    }
    this.setState({returned: !value})
  }

  toggleModal = () => {
    this.setState({ modalOpen: !this.state.modalOpen, initialZendeskTicket: null });
    this.props.resetZendeskFields();
  }

  togglePreviewModal = (id) => this.setState({ showReviewModal: id })

  toggleEditModal = (id) => this.setState({ editModalOpen: id })

  closeEditModal = () => this.setState({ editModalOpen: false })

  closeReviewModal = () => this.setState({ showReviewModal: false })

  copy = (textToCopy) => (e) => {
    e.stopPropagation();
    copy(textToCopy);
    this.props.notifyUser({
      message: `${textToCopy} Copied!`,
      type: 'success'
    });
  }

  render() {
    const openModalTrigger = (<Button icon='plus' onClick={this.toggleModal} primary className="NewRefundBtn" />);

    const userOptions = this.props.refunds && this.props.refunds.length ? Array.from(new Set(this.props.refunds.map(refund => refund.history && refund.history.length ? refund.history[0].user.email : 'Unknown'))) : []

    const countryOptions = this.props.refunds && this.props.operators ? Array
      .from(new Set(this.props.refunds.map(refund => refund.countryId)))
      .map(countryId => this.props.operators.find(operator => operator.countryId === countryId))
      .map(operator => ({ key: operator.countryISO, value: operator.countryISO, text: operator.countryName })) : []

    const operatorOptions = this.props.refunds && this.props.operators ? Array
      .from(new Set(this.props.refunds.map(refund => refund.oc)))
      .map(oc => this.props.operators.find(operator => operator.oc === oc))
      .map(operator => ({ key: operator.operatorName, value: operator.operatorName, text: operator.operatorName })) : []


    return (
      <div className="RefundRequestor main-content">
        <div className="RefundFilters">
          <div className="main-title">
              Request Refunds
            <span className="main-title__length"> {this.props.refunds.length}</span>
          </div>
          <div className="main-toolbar">
              <div className="main-toolbar_item">
                  <button onClick={this.toggleModal} className="NewRefundBtn btn btn_blue">New</button>
              </div>
              <div className="main-toolbar_item">
                <Input
                  onChange={this.onMsisdnChange}
                  icon={this.state.msisdn && this.state.msisdn.length ? <Icon name='remove' inverted circular link size="tiny" onClick={this.toggleReturned} /> : null}
                  placeholder="MSISDN Lookup"
                  value={this.state.msisdn}
                />
              </div>
          </div>
        </div>
        <ReactTable
          data={this.props.refunds.slice().sort(sortPriorities).map(refund => ({
            ...refund,
            priority: refund.priority === 'HIGH' ? <Icon name="angle double up" color="red" /> : <Icon name="angle double down" color="green" />,
            priorityValue: refund.priority,
            actions: refund.status === 'RETURNED' ? <div style={{textAlign: 'left'}}>
                    <Popup
                      trigger={<Button size="mini" className="button-approve" icon='edit' compact onClick={() => this.toggleEditModal(refund._id)}/>}
                      content="Edit"
                      inverted
                      size="mini"
                      position="bottom center"
                    />
            </div> : <div style={{textAlign: 'left'}}>
                    <Popup
                      trigger={<Button size="mini" className="button-approve" icon='external' compact onClick={() => this.togglePreviewModal(refund._id)}/>}
                      content="Preview"
                      inverted
                      size="mini"
                      position="bottom center"
                    />
            </div>,
            country: this.props.operators && this.props.operators.length ? <span><Flag name={this.props.operators.find(operator => operator.countryId === refund.countryId).countryISO.toLowerCase()} /> {this.props.operators.find(operator => operator.countryId === refund.countryId).countryISO}</span> : null,
            countryISO: this.props.operators && this.props.operators.length ? this.props.operators.find(operator => operator.countryId === refund.countryId).countryISO : null,
            operator: this.props.operators && this.props.operators.length ? this.props.operators.find(operator => operator.oc === refund.oc).operatorName : null,
            service: this.props.operators && this.props.operators.length ? this.props.operators.find(operator => operator.oc === refund.oc).services.find(service => refund.srvcId.toString() === service.id).name : null,
            createdAt: moment(refund.createdAt).format('YYYY-MM-DD HH:mm'),
            updatedAt: moment(refund.updatedAt).format('YYYY-MM-DD HH:mm'),
            msisdnWithCopy: <span>
              <Popup
                trigger={<Button size="mini" icon="clone" className="button-copy" circular onClick={this.copy(refund.msisdn)} />}
                content="Copy"
                inverted
                size="mini"
                position="bottom center"
              /> {refund.msisdn}
            </span>,
            idWithCopy: <span>
              <Popup
                trigger={<Button size="mini" icon="clone" className="button-copy" circular onClick={this.copy(refund._id)} />}
                content="Copy"
                inverted
                size="mini"
                position="bottom center"
              /> {refund._id}
            </span>,
            createdBy: refund.history && refund.history.length ? refund.history[0].user.email : 'Unknown'
          }))}
          columns={[
            {
              Header: 'Priority',
              accessor: 'priority',
              filterable: true,
              width: 77,
              filterMethod: ({value}, row) => value === row._original.priorityValue,
              Filter: ({ filter, onChange }) => <Dropdown
                compact
                placeholder="Priority"
                fluid
                search
                options={[
                  {key: '', value: '', text: 'Select All'},
                  {
                    key: "HIGH",
                    value: "HIGH",
                    text: <span className="priority-icon-form"><Icon name="angle double up" color="red" /> High</span>
                  }, {
                    key: "NORMAL",
                    value: "NORMAL",
                    text: <span className="priority-icon-form"><Icon name="angle double down" color="green" />Normal</span>
                  }
                ]}
                onChange={(e, {value}) => onChange(value)}
                value={ filter ? filter.value : '' }
              />
            },
            {Header: 'Case ID', width: 75, accessor: 'idWithCopy'},
            {Header: () => <span>Created At</span>,
                width: 145, accessor: 'createdAt'},
            {
              Header: () => <span>Created By</span>,
              width: 170,
              accessor: 'createdBy',
              filterable: true,
              Filter: ({ filter, onChange }) => <Dropdown
                compact
                placeholder="Created By"
                fluid
                search
                options={[
                  {key: '', value: '', text: 'Select All'},
                  ...userOptions.map(value => ({ key: value, value, text: value }))
                ]}
                onChange={(e, {value}) => onChange(value)}
                value={ filter ? filter.value : '' }
              />
            },
            {
              Header: () => <span>Country</span>,
              width: 75,
              accessor: 'country',
              sortMethod: (a, b) => defaultSort(a.props.children[2], b.props.children[2]),
              filterable: true,
              filterMethod: ({value}, row) => value === row._original.countryISO,
              Filter: ({ filter, onChange }) => <Dropdown
                compact
                placeholder="Country"
                fluid
                search
                options={[{key: '', value: '', text: 'Select All'}, ...countryOptions]}
                onChange={(e, {value}) => onChange(value)}
                value={ filter ? filter.value : '' }
              />
            },
            {
              Header: 'Operator',
              accessor: 'operator',
              filterable: true,
              Filter: ({ filter, onChange }) => <Dropdown
                compact
                placeholder="Operator"
                fluid
                search
                options={[{key: '', value: '', text: 'Select All'}, ...operatorOptions]}
                onChange={(e, {value}) => onChange(value)}
                value={ filter ? filter.value : '' }
              />
            },
            {Header: 'Service', accessor: 'service'},
            {Header: () => <span>Number</span>,
                width: 130, accessor: 'msisdnWithCopy', sortMethod: (val1, val2) => defaultSort(val1.props.children[2], val2.props.children[2]) },
            {Header: () => <span>Status</span>,
                width: 115, accessor: 'status'},
            {Header: () => <span>Updated</span>,
                width: 145, accessor: 'updatedAt'},
            {Header: () => <strong> </strong>,
                width: 69, accessor: 'actions', className: "right", sortable: false}
          ]}
          defaultPageSize={10}
          className="RefundRequestorTable -striped"
          getLoadingProps={() => ({
              loadingText:
                  <div className="loading-widget loading-widget_table">
                      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                          <g fill="none" fill-rule="evenodd">
                              <path className="loading-widget__draw-animation" stroke="#4061AD" stroke-width="1" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="10" stroke-dasharray="300" stroke-dashoffset="300" fill="none" d="M19.783 5.792V.793c0-.581-.476-.82-1.057-.555L6.137 6.188c-.582.265-1.058.952-1.058 1.534v20.972c0 .582.476.82 1.058.556l13.62-6.427-4.655 2.222V13.488l-2.565 1.269v-5.58l7.246-3.385z"/>
                              <path className="loading-widget__draw-animation" stroke="#14AFE4" stroke-width="1" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="10" stroke-dasharray="300" stroke-dashoffset="300" fill="none" d="M26.21 2.75L18.435 6.4l1.322-.635V22.77l-4.655 2.195V13.488l-2.538 1.269v16.45c0 .581.476.82 1.057.555l12.589-5.924c.582-.264 1.058-.952 1.058-1.534V3.332c0-.608-.476-.846-1.058-.582z"/>
                          </g>
                      </svg>
                  </div>
          })}
          getPaginationProps={() => ({
              nextText: <Icon name="icon1 icon1_angle-right"  />,
              previousText: <Icon name="icon1 icon1_angle-left" />

          })}
          loading={this.props.loading}
        />
        <NewRefundRequestModal
          trigger={openModalTrigger}
          getZendeskData={this.props.getZendeskData}
          createRefund={this.props.createRefund}
          zendeskData={this.props.zendeskData}
          zendeskDataLoading={this.props.zendeskDataLoading}
          zendeskDataLoaded={this.props.zendeskDataLoaded}
          open={this.state.modalOpen}
          initialZendeskTicket={this.state.initialZendeskTicket}
          operators={this.props.operators}
          close={this.toggleModal}
        />
        <EditReturnedRefundModal
          initialValues={this.props.refunds.find(refund => refund._id === this.state.editModalOpen)}
          open={this.state.editModalOpen}
          close={this.closeEditModal}
          updateStatus={this.props.updateReturnedRefund}
          addComment={this.props.addComment}
          operators={this.props.operators}
          updateReturnedRefund={this.props.updateReturnedRefund}
          uploadFiles={this.props.uploadFiles}
          uploading={this.props.uploading}
          transactions={this.props.transactions}
          getTransactions={this.props.getTransactions}
        />
        <ReviewRefundRequestModal
          initialValues={this.props.refunds.find(refund => refund._id === this.state.showReviewModal)}
          open={this.state.showReviewModal}
          close={this.closeReviewModal}
          refundCount={this.props.refundCount}
          getRefundsCount={this.props.getRefundsCount}
          addComment={this.props.addComment}
          operators={this.props.operators}
          type="requestor"
          uploadFiles={this.props.uploadFiles}
          uploading={this.props.uploading}
          transactions={this.props.transactions}
          getTransactions={this.props.getTransactions}
          loadingTransactions={this.props.loadingTransactions}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/RefundRequestorRouteComponent/RefundRequestor.js